/*
数据看板-工单数据
 */
import React, { Component } from "react";
import "@/assets/stylus/data_analysis.styl";
import PropTypes from "prop-types";
import "@ant-design/compatible/assets/index.css";
import { Affix, Tooltip, Modal } from "antd";
import FormCore from "@/components/display/form/formCore";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import moment from "moment";
// 业务接口
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import TicketNumCount from "./ticketNumCount";

import TicketTotalModal from "../../configurationManagement/stub/ticketTotalModal";
import CompanyTicketTotalModal from "../../configurationManagement/stub/companyTicketTotalModal";

import TicketBoardAreaSub from "./ticketBoardAreaSub";

import FaultChart from "./faultChart";

import { RightOutlined, QuestionCircleFilled} from "@ant-design/icons";

import "@/assets/stylus/displayBoard.styl";

import {
  queryTicketNewCountQry,
  qryByTicketType,
  userManagerRegionList,
  getChargeSuccessRateByFirmware,
  queryTicketAreaNumCityQry,
  getStopReason,getCityList,
  getFaultTypeTop, getFaultStationTop, getMaterialTop
} from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "./index.styl";

// 国际化切换语言

const SORT_TYPE_OPTIONS = [
  // value替换为对应字段
  { name: "订单总数", value: "0" },
  { name: "成功订单数", value: "1" },
  { name: "失败订单数", value: "2" },
  { name: "成功率", value: "3" },
];

const SORT_ORDER_OPTIONS = [
  { name: "从高到低", value: "-1" },
  { name: "从低到高", value: "1" },
];

@CityDataFilterHoc
@connect((state) => state)
class TicketPlat extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chargSuccess;

    this.props = props;
    this.state = {
      areaList:[
        {
          text: "全部",
          value: "",
        }],
      comEvHandleNum:0,
      evHandleNum:0,
      handleNum:0,
      finishNum:0,
      newNum:0,
      equipmentQry:{
        station:1,
        stub:1,
        powerBox:2,
      },
      appkey:null,
      chooseDate: moment(new Date()).subtract(0, "d"), // 选择的日期
      endDate:moment(new Date()).subtract(0, "d"),
      formConfig: null,
      appKeyList:[],
      typeOption: [
        {
          text: "全部",
          value: "",
        },
      ],
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        operationProperty: "3",
        chooseDate: moment(new Date()).subtract(0, "m"), // 选择的日期
        month:moment(new Date()).subtract(0, "m").format("YYYYMM"),
        successType: 1,
        searchType:'1',
      },
      hiddenDateS:2,
      timeType: "pickMonth", // 查询form表单 日期表单选择方式  pickMonth：年月选择； pickDate：年月日选择
      monthDataList: [], // 按月呈现数据源
      dailyDataList: [], // 按日呈现数据源
      firmwareDataList: [], // 固件版本数据源
      stopReasonDataList: [], // 停止原因数据源
      dataSource1: [],
      dataSource2: [],
      dataSource3: [],
      dataSource4: [],
      dataSource5: []
    };
  }

  componentWillMount() {
    
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.getAreaList();
    this.getCityList();
    this.initSource();

  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }
  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = '';
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (value[0].charAt(5) === "0" && value[0].charAt(4) === "0" && value[0].charAt(3) === "0" && value[0].charAt(2) === "0") {
        quanguoCityArryCVal = this.quanguoCityNotCity;
      } else {
        quanguoCityArryCVal = this.quanguoCityNotP;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    }
  };
  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, {cityType:1,userId:sessionStorage.getItem("userId")}).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      this.quanguoCityArry = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];

      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    });
  };

  /**
   * 获取负责的大区列表
   */
  getAreaList() {
    let that = this;
   fetchHandler(userManagerRegionList, {
     userId: sessionStorage.getItem("userId"),
   }).then((res) => {
     
     
     if (res.data) {
       res.data.forEach(function (item){
         item.text = item.regName;
         item.value = item.areaId;
       })
       res.data.unshift({
         text: "全部",
         value: "",
       })
       this.setState(
         {
           areaList:res.data,
         },
         () => {
           this.setState({
             formConfig: this.initFormConfig(),
           });
         },
       );
     }
   });
 }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  initFormConfig() {
    this.setState({
      isSearch: 1,
    });
    const formConfig = {
      childItems: [
        
        {
          type: "select",
          placeholder: "请选择", // '请选择大区',
          labelName: "大区", // '大区',
          param: {
            name: "areaIds",
            type: "string",
          },
          options: this.state.areaList,
          allowClear: true,
          required: false,
          onChange: async (value, form) => {
            if (value == null || value == '')
            {
              //恢复区域信息
              form.setFieldsValue({
                cityGroup:[]
              });
            } else {
              //遍历区域，把不属于
              form.setFieldsValue({
                cityGroup:value.split(',')
              });
            }
            this.setState({
              formConfig: this.initFormConfig(value),
            });
          },
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.all, // '全部',
              value: "",
            },
            {
              text: 'A类', // '交流',
              value: "1",
            },
            {
              text: 'B类', // '直流',
              value: "2",
            },
            {
              text: "C类", // '交直流',
              value: "3",
            },
          ],
          placeholder: "请选择城市类别",
          param: {
            name: "infoType",
            type: "string",
          },
          labelName: '城市类别', // '城市类别:',
          required: false,
          defaultValue: "",
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },
        
          
        {
          type: "date",
          dateType: "pickMonth",
          
          param: {
            name: "chooseDate",
            type: "object",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
          moment(new Date()).subtract(0, "m"),
          
          labelName: '日期', // '订单结束时间:',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                console.info('群里')
                console.info(param)
                // 设置城市数组
                let cityIds = "";
                var infoType = param.infoType;//城市类别
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  
                  if (param.cityGroup.length === 0) {
                    
                  console.info('问问3')
                    // cityIds = "000000";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item){
                      item.children.forEach(function (one){
                        if (infoType && infoType != null)
                        {
                          if (one.cityType == infoType)
                          {
                            ids.push(one.key);
                          }
                        }
                        else {
                          ids.push(one.key);
                        }
                      })
                    })
                    cityIds = ids.join(',')
                  } else if (param.cityGroup[0] === "000000") {
                    console.info('问问4')
                    // cityType = "0";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item){
                      item.children.forEach(function (one){
                        if (infoType && infoType != null)
                        {
                          if (one.cityType == infoType)
                          {
                            ids.push(one.key);
                          }
                        }
                        else {
                          ids.push(one.key);
                        }
                      })
                    })
                    cityIds = ids.join(',')
                  } else if (
                    param.cityGroup[0].charAt(5) === '0'
                    && param.cityGroup[0].charAt(4) === '0'
                    && param.cityGroup[0].charAt(3) === '0'
                    && param.cityGroup[0].charAt(2) === '0'
                  ) {
                    console.info('问问5')
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item){
                      if (param.cityGroup.indexOf(item.key) != -1)
                      {
                        item.children.forEach(function (one){
                          if (infoType && infoType != null)
                        {
                          if (one.cityType == infoType)
                          {
                            ids.push(one.key);
                          }
                        }
                        else {
                          ids.push(one.key);
                        }
                        })
                        item.children.forEach(function (one){
                          
                        })
                      }
                    })
                    cityIds = ids.join(',')
                  } else {
                    console.info('问问6' + cityIds)
                    cityType = "2";
                    this.state.quanguoCityArry[0].children.forEach(function (item){
                      item.children.forEach(function (one){
                        if (param.cityGroup.indexOf(one.key) != -1)
                        {
                          if (infoType && infoType != null)
                          {
                            if (one.cityType == infoType)
                            {
                              cityIds += `${one.key},`;
                            }
                          }
                          else {
                            cityIds += `${one.key},`;
                          }
                        }
                      })
                    })
                  }
                } else {
                  console.info('问问7')
                  var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item){
                      item.children.forEach(function (one){
                        if (infoType && infoType != null)
                        {
                          if (one.cityType == infoType)
                          {
                            ids.push(one.key);
                          }
                        }
                        else {
                          ids.push(one.key);
                        }
                      })
                    })
                    cityIds = ids.join(',')
                }
                var month = null;
                if (param.chooseDate != null && param.chooseDate != '')
                {
                  month = param.chooseDate.format("YYYYMM");
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? (cityIds || "") : "",
                      provinceIds: cityType === "0" || cityType === "1" ? (cityIds || "000000") : "",
                      stubType:param.stubType,
                      operationMode:param.operationMode,
                      projectNames:(param.projectNames && param.projectNames != null && param.projectNames.length > 0) ? param.projectNames.join(',') : null,
                      operationProperty: "3",
                      userId:param.userId,
                      infoType:param.infoType,
                      companyId:param.companyId,
                      month: month
                    },
                  },
                  () => {
                    // 查询订单累计数据
                    this.handleGetMonthData();
                    this.handleGetDailyData();
                    this.handleGetFaultData();
                  },
                );
              },
            },
          ],
        },
      ],
      defaultValue: {
        operationProperty: "3",
      },
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "taskTable",
    };

    return formConfig;
  }

  initSource = () => {
    this.handleGetMonthData();
    this.handleGetDailyData();
    this.handleGetFaultData();
    // this.handleGetFirmwareData();
    // this.handleGetStopReasonData();
  };

  setLoading = (key, val) => {
    this.setState({
      [`${key}Loading`]: val,
    });
  };

  getFormatter = () => {
    return this.state.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  // 获取累计数据
  handleGetMonthData = () => {
    if (this.state.param.infoType != null && (this.state.param.cityIds == null || this.state.param.cityIds == '') && (this.state.param.provinceIds == null || this.state.param.provinceIds == ''))
    {
      this.setState({
        monthDataList: [],
          comEvHandleNum:0,
          evHandleNum:0,
          handleNum:0,
          finishNum:0,
          newNum:0
      });
        return;
    }
    this.setLoading("month", true);
    fetchHandler(queryTicketNewCountQry, {
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      month: this.state.param.month
    }).then((res) => {
      if (res.data) {
        this.setState({
          monthDataList: res.data,
          comEvHandleNum:res.data.comEvHandleNum,
          evHandleNum:res.data.evHandleNum,
          handleNum:res.data.handleNum,
          finishNum:res.data.finishNum,
          newNum:res.data.newNum
        });
      }
      this.setLoading("month", false);
    });
  };

  // 获取日数据
  handleGetDailyData = () => {
    if (this.state.param.infoType != null && (this.state.param.cityIds == null || this.state.param.cityIds == '') && (this.state.param.provinceIds == null || this.state.param.provinceIds == ''))
    {
      this.setState({
        dailyDataList: []
      });
        return;
    }
    this.setLoading("day", true);
    fetchHandler(qryByTicketType, {
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      month: this.state.param.month
    }).then((res) => {
      if (res.data) {
        if (res.data.list && res.data.list.length > 0)
        {
          localStorage.setItem('ticketBoardData', JSON.stringify(res.data.list));
        } else {
          localStorage.setItem('ticketBoardData', JSON.stringify([]));
        }
        this.setState({
          dailyDataList: res.data,
        });
      }
      this.setLoading("day", false);
    });
  };

  // 获取故障类数据
  handleGetFaultData = () => {
    fetchHandler(getFaultTypeTop, {
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      month: this.state.param.month
    }).then((res) => {
      this.setState({
        dataSource1: res.data
      })
    })
    fetchHandler(getFaultStationTop, {
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      month: this.state.param.month
    }).then((res) => {
      this.setState({
        dataSource2: res.data
      })
    })
    fetchHandler(getMaterialTop, {
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      month: this.state.param.month
    }).then((res) => {
      this.setState({
        dataSource3: res.data.totalMaterialList,
        dataSource4: res.data.freeMaterialList,
        dataSource5: res.data.chargedMaterialList,
      })
    })  
  }

  // 获取固件成功率数据
  handleGetFirmwareData = () => {
    this.setLoading("firmware", true);

    fetchHandler(getChargeSuccessRateByFirmware, {
      ...this.state.params,
      time: this.state.chooseDate.format(this.getFormatter()) ,
      endTime:this.state.timeType === "pickMonth" ? null : this.state.endDate.format(this.getFormatter())
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          firmwareDataList: res.data,
        });
      }
      this.setLoading("firmware", false);
    });
  };

  // 获取停止原因数据源
  handleGetStopReasonData = () => {
    this.setLoading("stopReason", true);

    fetchHandler(getStopReason, {
      ...this.state.params,
      time: this.state.chooseDate.format(this.getFormatter()),
      endTime:this.state.timeType === "pickMonth" ? this.state.chooseDate.format(this.getFormatter()) : this.state.endDate.format(this.getFormatter())
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          stopReasonDataList: res.data,
        });
      }
      this.setLoading("stopReason", false);
    });
  };

  
   //type:1:累计创建工单，2：累计完成工单，3：处理总工时，4：平均处理时效，5：供应商平均处理时效
   getModalData(type, totalNum) {
    if (this.state.param.infoType != null && (this.state.param.cityIds == null || this.state.param.cityIds == '') && (this.state.param.provinceIds == null || this.state.param.provinceIds == ''))
    {
        return;
    }
   fetchHandler(queryTicketAreaNumCityQry, {
      type:type,
      operationMode:this.state.param.operationMode,
      stubType:this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      month: this.state.param.month
   }).then((res) => {
     if (res.data) {
      var list = [];
      var fAreaId = null;
      var index = 0;
       if (res.data.areaNums && res.data.areaNums.length > 0)
       {
        res.data.areaNums.forEach(function (item){
          var one = {};
          one.id = item.id;
          one.text = item.name;
          one.num = item.stationNum;
          if (index == 0) {
           fAreaId = item.id;
           one.choosed = 2;
           } else {
             one.choosed = 1;
           }
           index++;
          list.push(one)
        })
       }
       this.setState(
         {
          areaDTOList:list,
          fAreaId:fAreaId,
          modalType:type,
          modalTitle: type == 1 ? '累计创建工单数' : (type == 2 ? "累计完成工单数" : (type == 3 ? "处理总工时" : (type == 4 ? "平均处理时效（时）" : "供应商平均处理时效（时）"))),
          modalStationNum:totalNum,
          modalStationTitle:list.length > 0 ? list[0].text : ""
         },
         () => {
           this.setState({
            areaDTOList:list,
            fAreaId:fAreaId,
            modalTitle: type == 1 ? '累计创建工单数' : (type == 2 ? "累计完成工单数" : (type == 3 ? "处理总工时" : (type == 4 ? "平均处理时效（时）" : "供应商平均处理时效（时）"))),
            modalType:type,
            modalStationNum:totalNum,
            modalStationTitle:list.length > 0 ? list[0].text : ""
           });
           if (type == 5)
           {
            this.modalVisibleAction("statusLogllVisible", true);
           } else {
            this.modalVisibleAction("statusLogVisible", true);
            
           }
         },
       );
     }
   });
 }

  // 点击柱状图选择月份
  mcSetDate = async (date) => {
    await this.setState({
      chooseDate: date,
      endDate: date,
      timeType: "pickMonth",
    });
    // 重新加载数据
    this.handleGetDailyData();
    this.handleGetFirmwareData();
    this.handleGetStopReasonData();
    this.top100EquRef.handleGetDataSource();
    this.top10StationRef.handleGetDataSource();
    this.top50ChanelRef.handleGetDataSource();
  };

  // 点击柱状图选择日期
  dcSetDate = async (date) => {
    await this.setState({
      chooseDate: date,
      endDate: date,
      timeType: "pickDate",
    });
    this.handleGetFirmwareData();
    this.handleGetStopReasonData();
    this.top100EquRef.handleGetDataSource();
    this.top10StationRef.handleGetDataSource();
    this.top50ChanelRef.handleGetDataSource();
  };

  render() {
    const val = (
      <div
        className='analysis charge-success-rate-container'
        ref='chargSuccsessRate'
        style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
        {/* <Affix target={() => this.refs.chargSuccsessRate}> */}
          <div className='analysis-title'>
            <FormCore formConfig={this.state.formConfig} />
          </div>
        {/* </Affix> */}

        <div className='page-panel'>
          <div className='display-board'>
          <div className='item' style={{width:"100%"}}>
              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.getModalData(1, this.state.newNum);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      累计创建工单数{" "}<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内创建的工单总数</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className='num'>{this.state.newNum}</div>
                  </div>
                </div>
              </div>
              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.getModalData(2, this.state.finishNum);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      累计完成工单数<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内累计完成的总工单数</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                      
                    </div>
                    <div className='num' style={{display:"flex", justifyContent:"space-between"}}>
                      <div>{this.state.finishNum}</div>
                      {/* <div style={{fontSize:"14px", color:"#a9a1a1"}}>56%</div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.getModalData(3, this.state.handleNum);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        处理总工时<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内处理的总工时：处理工时=验收通过时间-工单创建时间</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                     
                    </div>
                    <div className='num' style={{display:"flex", justifyContent:"space-between"}}>
                      <div>{this.state.handleNum}</div>
                      {/* <div style={{fontSize:"14px", color:"#a9a1a1"}}>56%</div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.getModalData(4, this.state.evHandleNum);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        平均处理时效(时)<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内处理总工时除以完成工单数量</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className='num' style={{display:"flex", justifyContent:"space-between"}}>
                      <div>{this.state.evHandleNum}</div>
                      {/* <div style={{fontSize:"14px", color:"#a9a1a1"}}>56%</div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.getModalData(5, this.state.comEvHandleNum);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        供应商平均处理时效(时)<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内供应商处理的总工时除以处理的工单数</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className='num' style={{display:"flex", justifyContent:"space-between"}}>
                      <div>{this.state.comEvHandleNum}</div>
                      {/* <div style={{fontSize:"14px", color:"#a9a1a1"}}>56%</div> */}
                    </div>
                  </div>
                </div>
              </div>


            </div>


            
            
           

          </div>
        </div>
        
        <TicketNumCount
          {...this.props}
          dataSource={this.state.dailyDataList}
          setChooseDate={this.dcSetDate}
          chooseDate={this.state.chooseDate}
          timeType={this.state.timeType}
          endDate={this.state.endDate}
          loading={this.state.dayLoading}
        />
        
       
        <TicketBoardAreaSub
              {...this.props}
              timeType={this.state.timeType}
              chooseDate={this.state.chooseDate}
              endDate={this.state.endDate}
              sortOrderOptions={SORT_ORDER_OPTIONS}
              sortTypeOptions={SORT_TYPE_OPTIONS}
              params={this.state.param}
              ref={(ref) => (this.top100EquRef = ref)}
            />
        <FaultChart
          dataSource1={this.state.dataSource1}
          dataSource2={this.state.dataSource2}
          dataSource3={this.state.dataSource3}
          dataSource4={this.state.dataSource4}
          dataSource5={this.state.dataSource5}
          />

<Modal
          title={this.state.modalTitle}
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <TicketTotalModal modalParam={this.state.param} stubIdData={this.state.areaDTOList} modalType={this.state.modalType} firstId={this.state.fAreaId} modalStationTitle={this.state.modalStationTitle} modalStationNum={this.state.modalStationNum} />
        </Modal>

        <Modal
          title={this.state.modalTitle}
          visible={this.state.statusLogllVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogllVisible", false);
          }}>
          <CompanyTicketTotalModal modalParam={this.state.param} stubIdData={this.state.areaDTOList} modalType={this.state.modalType} firstId={this.state.fAreaId} modalStationTitle={this.state.modalStationTitle} modalStationNum={this.state.modalStationNum} />
        </Modal>

        

      </div>
    );
    return val;
  }
}

export default injectIntl(TicketPlat);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/ticketPlat.js